import {
  Box,
  Card,
  CardBody,
  Divider,
  Flex,
  HStack,
  Image,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { customCurrencyFormat, getPixelCount } from "../../../utils";
import InfoTooltip from "./advancedMetricsLowerCard";

export const AdvancedMetricUpperCard = ({
  target = "-",
  actual = "-",
  changePercent = "-",
  titleLeft = "",
  titleRight = "",
  percentageColor,
  symbol,
  iconBg = "blue.50",
  image,
  detailInfo,
}) => {
  const labelColor = useColorModeValue("#718096", "#A0AEC0");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  const cardRef = useRef(null);
  const [hideImage, setHideImage] = useState(false);

  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      const width = entry.contentRect.width;
      setHideImage(width < 420);
    });

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <Card
      bg="white"
      borderRadius="10px"
      boxShadow="sm"
      borderColor={borderColor}
      width={"100%"}
      minW={0}
      minH={"108px"}
      ref={cardRef}
    >
      <CardBody p={"16px"} display="flex" alignItems="center">
        <HStack spacing={4} align="center" justify="space-between" w="100%">
          <VStack align="flex-start" spacing={1} flex="1" minW={0}>
            <Flex w="100%" align="center" gap="1">
              <Text fontSize="14px" color={labelColor}>
                {titleLeft}
              </Text>
              <InfoTooltip detailInfo={detailInfo} />
            </Flex>
            <Text
              fontSize={getPixelCount(
                { base: "25px", md: "28px", lg: "30px" },
                customCurrencyFormat(target, false, false, true, false),
                8,
                1
              )}
              fontWeight="700"
              color="black"
              lineHeight="1.1"
            >
              {customCurrencyFormat(target, false, false, true, false)}
            </Text>
          </VStack>

          <Divider
            orientation="vertical"
            h="61px"
            borderColor={"#DFE6E9"}
            alignSelf="center"
          />

          <VStack align="flex-start" spacing={0} flex="1" minW={0}>
            <Text
              fontSize="14px"
              color={labelColor}
              whiteSpace={"wrap"}
              width={"95%"}
            >
              {titleRight}
            </Text>

            <Flex wrap="wrap" gap={2} align="baseline">
              <Text
                fontSize={getPixelCount(
                  "20px",
                  customCurrencyFormat(actual, false, false, true, false),
                  8,
                  1
                )}
                fontWeight="600"
                color="black"
              >
                {customCurrencyFormat(actual, false, false, true, false)}
              </Text>

              <Text
                fontSize="14px"
                fontWeight="600"
                lineHeight="18px"
                color={percentageColor}
              >
                {customCurrencyFormat(
                  changePercent,
                  true,
                  false,
                  true,
                  true,
                  false,
                  true
                )}
              </Text>
            </Flex>
          </VStack>

          {!hideImage && (
            <Box
              flexShrink={0}
              w="61px"
              h="61px"
              borderRadius="lg"
              bg={iconBg}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Image width={"40px"} height={"40px"} src={image} />
            </Box>
          )}
        </HStack>
      </CardBody>
    </Card>
  );
};
